'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n'], ['\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouterDom = require('react-router-dom');

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Buttons = require('./Buttons');

var _styles = require('./styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var aStyle = '\n  cursor: pointer;\n  transition: color .2s linear;\n  text-decoration: none;\n  color: ' + _styles.styles.colors.darkfg + ';\n  &:hover {\n      color: ' + _styles.styles.colors.title_decoration + ';\n  }\n  &.active {\n      color: ' + _styles.styles.colors.mediumfg + ';\n  }\n';

var AButton = _Buttons.Button /*: any */.withComponent('a');
var LinkButton = _Buttons.Button /*: any */.withComponent(_reactRouterDom.Link);
var A = _styledComponents2.default.a(_templateObject, aStyle);
A.displayName = 'A';
var LinkA = A /*: any */.withComponent(_reactRouterDom.Link);

/*::
type SmoothProps = {|
    to: string,
    children?: React.Node,
|}
*/
var Smooth /*: ComponentType<SmoothProps> */ = (0, _styledComponents2.default)(function (props /*: SmoothProps */) {
  return React.createElement(
    _reactScroll2.default.Link,
    Object.assign({}, props, {
      spy: true,
      smooth: true,
      activeClass: 'active',
      offset: -65 }),
    props.children
  );
})(_templateObject2, aStyle);
Smooth.displayName = 'Smooth';
var SmoothButton = _Buttons.Button /*: any */.withComponent(Smooth);
/*::
type LinkProps = {
  children?: React.Node,
  href: string,
  button: ?bool,
}
*/
var Link /*: ComponentType<LinkProps> */ = (0, _styledComponents2.default)(function (_ref) {
  var href = _ref.href,
      _ref$button = _ref.button,
      button = _ref$button === undefined ? false : _ref$button,
      props = _objectWithoutProperties(_ref, ['href', 'button']);

  if (!href) {
    return null;
  }
  var hrefIsExternal = href.startsWith('http');
  var hrefIsId = href.startsWith('#');
  if (button) {
    return hrefIsExternal ? React.createElement(AButton, Object.assign({ href: href, target: '_blank' }, props)) : hrefIsId ? React.createElement(SmoothButton, Object.assign({ to: href.substring(1) }, props)) : React.createElement(LinkButton, Object.assign({ to: href }, props));
  }
  return hrefIsExternal ? React.createElement(A, Object.assign({ href: href, target: '_blank' }, props)) : hrefIsId ? React.createElement(Smooth, Object.assign({ to: href.substring(1) }, props)) : React.createElement(LinkA, Object.assign({ to: href }, props));
})(_templateObject3);
exports.Link = Link;
Link.displayName = 'Link';
Link.propTypes = {
  href: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Link.js
// module id = 631
// module chunks = 0